'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "RadioButton": "Polaris-RadioButton",
  "Input": "Polaris-RadioButton__Input",
  "Backdrop": "Polaris-RadioButton__Backdrop",
  "ChoiceLabel": "Polaris-RadioButton__ChoiceLabel",
  "toneMagic": "Polaris-RadioButton--toneMagic"
};

exports.default = styles;
